"use client";
import "./globals.css";
import {
    DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel,
    DropdownMenuSeparator, DropdownMenuTrigger
} from "@/components/ui/dropdown-menu";
import {Avatar, AvatarFallback, AvatarImage} from "@/components/ui/avatar";
import {Button} from "@/components/ui/button";
import {Building2, Search} from "lucide-react";
import {Input} from "@/components/ui/input";
import {MeApi,} from "@/api/generated";
import {getApiConfig, getAuthStatus} from "@/api/api";
import {useState, createContext, useEffect} from "react";
import {AppSidebar} from "@/components/app-sidebar";
import {Sidebar, SidebarInset, SidebarMenu, SidebarMenuItem, SidebarProvider} from "@/components/ui/sidebar";
import {Skeleton} from "@/components/ui/skeleton";
import AuthenticatedLayout from "@/AuthenticatedLayout";
import {AuthProvider, useAuth} from "@/context/AuthContext";
import {OrgProvider} from "@/context/OrgContext";
import {Toaster} from "@/components/ui/sonner";
import {ThemeProvider} from "@/components/theme-provider";
import {FloatingApiStatusButton} from "@/components/debug/floating-api-status-button";
import ClientOnly from "@/components/client-only";
import "../axiosSetup"
import {useRouter} from "next/navigation";

function SubLayout({ children }: { children: React.ReactNode }) {
    const authContext = useAuth();
    const router = useRouter();
    


    if(authContext.isAuthLoading) {
        return (
            <ThemeProvider
                attribute="class"
                defaultTheme="system"
                enableSystem
                disableTransitionOnChange
            >
                <div>
                    <div className="min-h-screen flex flex-col items-center justify-center bg-background">
                        <div className="relative w-16 h-16 mb-4">
                            <div className="absolute inset-0 rounded-full border-4 border-primary/20 animate-ping"></div>
                            <div className="absolute inset-1 rounded-full border-4 border-t-primary border-l-primary border-r-transparent border-b-transparent animate-spin"></div>
                        </div>
                        <h2 className="text-xl font-medium text-primary animate-pulse">Loading your dashboard...</h2>
                        <p className="text-muted-foreground mt-2">Please wait while we prepare your experience</p>
                    </div>
                </div>
            </ThemeProvider>
        )
    }

    else {
        if (!authContext.isAuthLoading && !authContext.user) {
            const currentPath = typeof window !== 'undefined' ? window.location.pathname : '';
            const noAuthPaths = ["/login", "/about-us"];
            if (!noAuthPaths.some(path => currentPath.includes(path))) {
                if (typeof window !== 'undefined') {
                    localStorage.setItem("redirectAfterLogin", window.location.href);
                }
                router.push("/login");
            }
        }

        return (
            <ThemeProvider
                attribute="class"
                defaultTheme="system"
                enableSystem
                disableTransitionOnChange
            >
                <OrgProvider>
                    <ClientOnly>
                        {authContext.user &&
                            <AuthenticatedLayout>
                                <main className="flex-1 flex w-full">
                                    {children}
                                </main>
                                <Toaster/>
                                <FloatingApiStatusButton/>
                            </AuthenticatedLayout>
                        }
                        {!authContext.user && <div>
                            {children}
                        </div>
                        }
                        <Toaster/>
                        <FloatingApiStatusButton/>
                    </ClientOnly>
                    <Toaster/>
                </OrgProvider>
            </ThemeProvider>
        );
    }
}

export default function RootLayout({
                                       children,
                                   }: Readonly<{
    children: React.ReactNode;
}>) {
    return (
        <html suppressHydrationWarning lang="en">
            <body className="min-h-screen flex flex-col">
                <AuthProvider>
                    <SubLayout>{children}</SubLayout>
                </AuthProvider>
            </body>
        </html>
    )
}
